import { useEffect, useState } from "react";

const useBrowserCheck = () => {
    const [browser, setBrowser] = useState({
        isChrome: false,
        isSafari: false,
        isFirefox: false,
    });

    useEffect(() => {
        const { userAgent } = navigator;
        let isChrome = /Chrome/.test(userAgent) && !/Edge/.test(userAgent);
        let isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
        let isFirefox = /Firefox/.test(userAgent);
        setBrowser({
            isChrome,
            isSafari,
            isFirefox,
        });
    }, []);

    return browser;
};

export default useBrowserCheck;
